import React from "react"

import { customColor } from "../../helpers/colorHelper"
import {
  LOGIN_URL, TERMS_OF_USE_URL, PRIVACY_POLICY_URL, REGISTRATION_ENDPOINT,
} from "../../constants/urls"

interface SignupFormProps {
  title?: string,
  cta?: string,
  code?: string,
  buttonColor?: string,
  buttonTextColor?: string,
  buttonHoverColor?: string,
  buttonActiveColor?: string,
  textColor?: string,
  backgroundColor?: string,
  minimal?: boolean,
}

class SignupFormInner extends React.PureComponent<SignupFormProps> {
  static defaultProps: SignupFormProps = {
    title: "Sign up to try Gobble's 15 minute dinner kits!",
    cta: "Get started now!",
    code: "",
    minimal: false,
    buttonColor: "black",
    buttonTextColor: "white",
    buttonHoverColor: "black-secondary",
    buttonActiveColor: "gray-dark",
  }

  bodyClass() {
    const { minimal } = this.props

    if (!minimal) {
      return "rounded-lg bg-white shadow-[0_4px_8px_0px_rgba(0,0,0,0.2)] box-border p-6"
    }
  }

  hiddenWhenMinimal() {
    const { minimal } = this.props

    if (minimal) {
      return "hidden"
    }
  }

  render() {
    const {
      cta,
      title,
      code,
      buttonColor,
      buttonTextColor,
      buttonHoverColor,
      buttonActiveColor,
      textColor,
      backgroundColor,
    } = this.props

    return (
      <div
        className={`${this.bodyClass()} text-xl max-w-xl w-full text-black-secondary`}
        style={customColor({ background: backgroundColor, text: textColor })}
      >
        <h4 className={`font-bold text-xl mb-2 ${this.hiddenWhenMinimal()}`}>{title}</h4>
        <form className="form" action={REGISTRATION_ENDPOINT} method="POST">
          <div className="mb-4">
            <label htmlFor="registration_email" className="sr-only">Email</label>
            <input
              type="text"
              placeholder="Your Email Address"
              className="text-lg text-black-secondary border border-solid border-gray-400 w-full px-4 py-2 focus:border-primary shadow-inner"
              id="registration_email"
              name="registration[email]"
              required
            />
          </div>
          <div className="mb-4">
            <label className="sr-only" htmlFor="password">Password</label>
            <input
              type="password"
              placeholder="Create a Password"
              className="text-lg text-black-secondary border border-solid border-gray-400 w-full px-4 py-2 focus:border-primary shadow-inner"
              id="password"
              name="registration[password]"
              minLength={4}
              required
            />
          </div>
          <div className="mb-4">
            <label className="sr-only" htmlFor="zip_code">Zipcode</label>
            <input
              type="string"
              placeholder="Your ZIP code"
              className="text-lg text-black-secondary border border-solid border-gray-400 w-full px-4 py-2 focus:border-primary shadow-inner"
              id="zip_code"
              name="registration[zip_code]"
              maxLength={5}
              required
            />
          </div>
          <div className="form-field">
            <input
              type="hidden"
              name="promo_code"
              value={code}
            />
          </div>
          <button
            type="submit"
            data-analytics="signup-cta"
            className={`inline-block text-center font-bold rounded-full leading-snug
              no-underline transition-all duration-200 ease-in-out
              active:[box-shadow:0px_4px_4px_0px_rgba(0,0,0,0.25)_inset]
              hover:no-underline w-full text-base border border-transparent
              mt-2 px-6 py-3.5 bg-${buttonColor} text-${buttonTextColor}
              hover:bg-${buttonHoverColor} active:bg-${buttonActiveColor}`}
          >
            {cta}
          </button>
        </form>
        <p className="pt-4 text-xs text-center">
          By clicking
          {" "}
          {cta}
          , you agree to receive emails from Gobble, our
          <a href={TERMS_OF_USE_URL} className="font-semibold underline mx-1 text-current" style={{ color: "inherit", textDecoration: "underline" }}>
            Terms of Use
          </a>
          and consent to our
          <a href={PRIVACY_POLICY_URL} className="font-semibold underline mx-1 text-current" style={{ color: "inherit", textDecoration: "underline" }}>Privacy Policy</a>
          . Gobble is a subscription service.
        </p>
        <p className={`pt-4 text-xs text-center ${this.hiddenWhenMinimal()}`}>
          Already a member?
          <a href={LOGIN_URL} className="font-semibold underline mx-1 text-current" style={{ color: "inherit", textDecoration: "underline" }}>Login</a>
        </p>
      </div>
    )
  }
}

export function SignupForm(props: SignupFormProps) {
  return <SignupFormInner {...props} />
}
